<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminServ.queryCondition') }}</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="adminServInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="adminServInfo.conditions.servName" :placeholder="$t('adminServ.inputServName')"
                  clearable style="width:100%"></el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="adminServInfo.conditions.hktId" :placeholder="$t('adminServ.selectServiceType')"
                  clearable style="width:100%">
                  <el-option v-for="item in adminServInfo.housekeepingTypes" :key="item.hktId" :label="item.hktName"
                    :value="item.hktId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="_queryAdminServMethod">{{ $t('adminServ.query')
                }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminServ.onShelvesService') }}</span>
          </div>
          <el-table :data="adminServInfo.housekeepingServs" border style="width: 100%">
            <el-table-column prop="shopName" :label="$t('adminServ.shop')" align="center" width="120"></el-table-column>
            <el-table-column prop="servId" :label="$t('adminServ.serviceNumber')" align="center"
              width="120"></el-table-column>
            <el-table-column prop="servName" :label="$t('adminServ.serviceName')" align="center"
              width="150"></el-table-column>
            <el-table-column prop="hktName" :label="$t('adminServ.serviceType')" align="center"
              width="120"></el-table-column>
            <el-table-column prop="repairWay" :label="$t('adminServ.dispatchMethod')" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.repairWay === '100'">{{ $t('adminServ.grabOrder') }}</span>
                <span v-else-if="scope.row.repairWay === '200'">{{ $t('adminServ.assign') }}</span>
                <span v-else-if="scope.row.repairWay === '300'">{{ $t('adminServ.roundRobin') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="returnVisitFlag" :label="$t('adminServ.returnVisitMethod')" align="center"
              width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.returnVisitFlag === '001'">{{ $t('adminServ.noReturnVisit') }}</span>
                <span v-else-if="scope.row.returnVisitFlag === '002'">{{ $t('adminServ.noReturnVisitAfterComment')
                }}</span>
                <span v-else-if="scope.row.returnVisitFlag === '003'">{{ $t('adminServ.allReturnVisit') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sales" :label="$t('adminServ.salesVolume')" align="center"
              width="100"></el-table-column>
            <el-table-column prop="defaultFee" :label="$t('adminServ.defaultFee')" align="center"
              width="120"></el-table-column>
            <el-table-column prop="sort" :label="$t('adminServ.sort')" align="center" width="80"></el-table-column>
            <el-table-column prop="state" :label="$t('adminServ.shelvesStatus')" align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.state === '1001' ? $t('adminServ.notOnShelves') : $t('adminServ.onShelves') }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('adminServ.shelvesTime')" align="center"
              width="180"></el-table-column>
            <el-table-column :label="$t('adminServ.operation')" align="center" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="_viewServDetail(scope.row)">{{ $t('adminServ.view') }}</el-button>
                <el-button size="mini" type="danger" @click="_openDeleteAdminServModel(scope.row)">{{
                  $t('adminServ.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="adminServInfo.conditions.page"
            :page-size="adminServInfo.conditions.row" layout="total, prev, pager, next"
            :total="adminServInfo.total"></el-pagination>
        </el-card>
      </el-col>
    </el-row>
    <delete-admin-serv ref="deleteAdminServ" @refresh="_listAdminServs"></delete-admin-serv>
    <view-qrcode ref="viewQrcode" />
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAdminServ, queryHousekeepingType } from '@/api/admin/adminServ/adminServApi'
import AdminShop from '@/components/shop/adminShop'
import DeleteAdminServ from '@/components/admin/deleteAdminServ/deleteAdminServ'
import ViewQrcode from '@/components/system/viewQrcode'

export default {
  name: 'AdminServ',
  components: {
    AdminShop,
    DeleteAdminServ,
    ViewQrcode
  },
  data() {
    return {
      adminServInfo: {
        housekeepingServs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        servId: '',
        componentShow: 'adminServ',
        housekeepingTypes: [],
        conditions: {
          repairWay: '',
          servName: '',
          hktId: '',
          state: '2002',
          createTime: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAdminServs()
    this._listHousekeepingTypes()
  },
  methods: {
    handleShopChange(shop) {
      this.adminServInfo.conditions.shopId = shop.shopId
      this._listAdminServs()
    },
    handleCurrentChange(val) {
      this.adminServInfo.conditions.page = val
      this._listAdminServs()
    },
    async _listHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 50,
          typeCd: 1001,
          shopId: getShopId()
        }
        const res = await queryHousekeepingType(params)
        this.adminServInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取家政服务类型失败:', error)
      }
    },
    async _listAdminServs() {
      try {
        const res = await queryAdminServ(this.adminServInfo.conditions)
        this.adminServInfo.total = res.total
        this.adminServInfo.records = res.records
        this.adminServInfo.housekeepingServs = res.data
      } catch (error) {
        console.error('获取家政服务列表失败:', error)
      }
    },
    _queryAdminServMethod() {
      this.adminServInfo.conditions.page = 1
      this._listAdminServs()
    },
    _openDeleteAdminServModel(housekeepingServ) {
      this.$refs.deleteAdminServ.open(housekeepingServ)
    },
    _viewServDetail(serv) {
      console.log(this.adminServInfo.moreCondition)
      this.$refs.viewQrcode.open({
        qrcodeName: serv.servName,
        qrCodeUrl: serv.pageUrl,
        remark: this.$t('adminServ.scanToViewService')
      })
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.filter-container {
  padding-bottom: 10px;
}

.box-card {
  margin-bottom: 20px;
}
</style>